module.exports = __webpack_public_path__ + "img/top-img.55e7461d.png";